import { Flex, FlexProps } from '@chakra-ui/react';
import { ReactNode } from 'react';

interface EntityDirectoryFilterBarProps extends FlexProps {
  actions?: ReactNode;
  children: ReactNode;
}

export function EntityDirectoryFilterBar({
  actions,
  children,
  ...props
}: EntityDirectoryFilterBarProps) {
  return (
    <Flex
      align={{ base: 'stretch', md: 'center' }}
      bg="entityDirectory.surface"
      border="1px solid"
      borderColor="entityDirectory.border"
      direction={{ base: 'column', md: 'row' }}
      gap={4}
      justify="space-between"
      minH="62px"
      px="14px"
      py={3}
      {...props}
    >
      <Flex
        align={{ base: 'stretch', md: 'center' }}
        direction={{ base: 'column', md: 'row' }}
        flex={1}
        flexWrap="wrap"
        gap={3}
      >
        {children}
      </Flex>
      {actions}
    </Flex>
  );
}
